// extracted by mini-css-extract-plugin
module.exports = {"custom-modal":"GlobalModal_custom-modal__3XSB1","modal-dialog":"GlobalModal_modal-dialog__3Rtc8","modal-content":"GlobalModal_modal-content__35WWZ"};